<template>
    <modal v-model="opened" :transition='0'>
        <div slot="header">
            <a id="close_popup" @click="close_popup"></a>
            <h3 class="modal-title">Update Event</h3>
        </div>
        <div class="row" style="margin-bottom: 15px">
            <div class="col-sm-12">
                <div class="">
                    This is a repeated Event. You have three options:
                </div>
                <div class="margin-5-top">
                    1) Update the whole chain of Events, past and future.
                </div>
                <div class="margin-5-top">
                    2) Update this Event on this date only.
                </div>
                <div class="margin-5-top">
                    3) Update this and future Events only.
                </div>
            </div>
        </div>
        <div class="select-menu-container center">
            <div class="select-menu-item">
                <div class="panel panel-danger">
                    <div class="panel-heading shortcuts" @click="select('whole')">
                        <h3 class="panel-title">Every<br>occurrence</h3>
                        <i class="fa fa-repeat select-menu-item__main-icon" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div class="select-menu-item">
                <div class="panel panel-primary">
                    <div class="panel-heading shortcuts" @click="select('exact')">
                        <h3 class="panel-title">Only<br>{{ formattedDate }}</h3>
                        <i class="fa fa-calendar-o select-menu-item__main-icon" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div class="select-menu-item">
                <div class="panel panel-primary">
                    <div class="panel-heading shortcuts" @click="select('since')">
                        <h3 class="panel-title">Future<br>Events</h3>
                        <i class="fa  fa-arrow-right select-menu-item__main-icon" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer"></div>
    </modal>
</template>

<script>
    import PopupMixin from "../../../../vue/mixins/PopupMixin";

    export default {
        name: "DeleteRepeatedEventTypeSelectorPopup",
        mixins: [PopupMixin],
        data() {
            return {
                opened: false,
                resolve: undefined,
                reject: undefined,
                date: undefined
            };
        },
        computed: {
            formattedDate() {
                if (!this.date) {
                    return;
                }
                return this.date.format('D MMM');
            },
        },
        methods: {

            show(date) {
                this.date = date;
                const self = this;
                this.opened = true;
                return new Promise((resolve, reject) => {
                    self.resolve = resolve;
                    self.reject = reject;
                });
            },
            select(what) {
                this.resolve(what);
                this.info = '';
                this.close();
            },
            close_popup() {
                this.info = '';
                this.reject('close');
                this.close();
            }
        }

    };
</script>

<style scoped>

</style>